import ReactLoading from 'react-loading';


const PageLoader = ({ type, color }) => (
        <ReactLoading type={type} color={color} height={200} width={175} className="page-loader" />
);

export default PageLoader;
